// EditableText.js
import React, { useState, useEffect, useRef } from "react";

const EditableText = ({ id, defaultText = "", onChange }) => {
  const [content, setContent] = useState("");
  const ref = useRef(null);

  // Load saved content (from localStorage or default)
  useEffect(() => {
    const saved = localStorage.getItem(`editable-${id}`);
    setContent(saved || defaultText);
  }, [id, defaultText]);

  // Handle edits
  const handleInput = (e) => {
    const newText = e.target.innerText;
    setContent(newText);
    localStorage.setItem(`editable-${id}`, newText);
    if (onChange) onChange(newText);
  };

  return (
    <span
      ref={ref}
      contentEditable
      suppressContentEditableWarning={true}
      onInput={handleInput}
    >
      {content}
    </span>
  );
};

export default EditableText;
